






























import { Component, Mixins } from "vue-property-decorator";
import { DialogMixin } from "../../../../system/mixins";

/**
 * TODO: FormatReferenceTreeAddFolderDialog.vueにほぼ同じ処理があるのでどこかのタイミングで統一したほうが良い
 */
@Component({
  components: {
  }
})
export default class NameInputDialog extends Mixins(DialogMixin) {
  data() {
    return {
      dialogTitle: "",
      inputLabel: "",
      resultValue: "",
      editingText: "",
    };
  }
  dialogTitle: string;
  inputLabel: string;
  resultValue: string;
  editingText: string;

  get hasValue(): boolean {
    return (this.editingText.length > 0);
  }

  async show(dialogTitle: string, inputLabel: string): Promise<string> {
    return this.showModal(async () => {
      this.dialogTitle = dialogTitle;
      this.inputLabel = inputLabel;
      this.resultValue = "";
      this.editingText = "";
      this.$nextTick(() => {
        const element = this.$refs.input as HTMLInputElement;
        element.focus();
      });
      await this.waitHidden();
      return this.resultValue;
    });
  }

  inputAndClose(): void {
    if (!this.hasValue) { return; }
    this.resultValue = this.editingText;
    this.isVisible = false;
  }

  cancelAndClose(): void {
    this.resultValue = "";
    this.isVisible = false;
  }
}
